export default {
  list: ({ list }) => list,
};
